import React, { useState, useRef, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { FaRobot } from "react-icons/fa";
import "./Image.css";
import CameraApp from "./CameraApp";
import { useConfig } from "../../context/ConfigProvider";
import StatsComponent from "../../components/StatsComponent";

const Images = ({ showRoboIcon = true, images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showCamera, setShowCamera] = useState(false);
  const [customerKey, setCustomerKey] = useState(0);
  const [ocid, setOcid] = useState(0);
  const imageRefs = useRef([]);
  const [configFetched, setConfigFetched] = useState(false);
  const { fetchConfig } = useConfig();
  const [debugMode] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("debug") === "true";
  });
  const [useDefault] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const value = decodeURIComponent(params.get("useDefault") || "");
    console.log("useDefault param value:", value);
    return value.toLowerCase() === "true";
  });
  const [statsMap, setStatsMap] = useState(new Map([]));

  const transformImageUrl = (url) => {
    console.log("Transforming URL:", url);
    console.log("useDefault value:", useDefault);

    if (useDefault === true) {
      console.log("Using original S3 URL");
      return url;
    }
    console.log("Using CloudFront URL");
    return url.replace(
      "https://ceimages.s3.amazonaws.com/",
      "https://d22uqmtf5jk3kz.cloudfront.net/"
    );
  };

  const transformedImages = images.map(transformImageUrl);

  const addStat = (key, value) => {
    setStatsMap((prev) => {
      const updated = new Map(prev);
      updated.set(key, value);
      return updated;
    });
  };

  useEffect(() => {
    if (!configFetched) {
      const params = new URLSearchParams(window.location.search);
      const customerKeyxOcid = params.get("exp");
      if (customerKeyxOcid) {
        const [ck, oid] = customerKeyxOcid.split("x");
        setCustomerKey(parseInt(ck, 10));
        setOcid(parseInt(oid, 10));
        fetchConfig(ck, oid);
        setConfigFetched(true);
      }
    }
  }, [configFetched, fetchConfig]);

  const handleScroll = (e) => {
    const { scrollTop, clientHeight } = e.target;
    const newIndex = Math.round(scrollTop / clientHeight);
    if (newIndex !== currentIndex) {
      setCurrentIndex(newIndex);
    }
  };

  return (
    <>
      <div className="reels-container" onScroll={handleScroll}>
        {loading && <ClipLoader color="#fff" size={50} className="loader" />}
        {transformedImages.map((image, index) => (
          <div className="reel" key={index}>
            <img
              ref={(el) => (imageRefs.current[index] = el)}
              src={image}
              alt={`Image ${index + 1}`}
              onLoad={(e) => {
                setLoading(false);
                if (debugMode) {
                  const loadTime = performance.now();
                  addStat(
                    `Image ${index + 1} Load Time`,
                    `${loadTime.toFixed(2)}ms`
                  );
                  addStat(
                    `Image ${index + 1} Dimensions`,
                    `${e.target.naturalWidth}x${e.target.naturalHeight}`
                  );
                }
              }}
            />
          </div>
        ))}

        {showRoboIcon ? (
          <div className="robo-container">
            {!showCamera ? (
              <FaRobot
                className="robo-icon"
                onClick={() => setShowCamera(true)}
              />
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        {showCamera && (
          <CameraApp
            cKey={customerKey}
            oId={ocid}
            onClose={() => {
              setShowCamera(false);
            }}
          />
        )}
      </div>
      {debugMode && <StatsComponent data={statsMap} />}
    </>
  );
};

export default Images;
